import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertDialogService } from "./../../components/_alert-dialog/alert-dialog.service";
import { BanqueDialogService } from "./banque-dialog.service";
import { Administre } from "../../interfaces/Administre";
import { Banque } from "../../interfaces/Banque";

@Component({
  selector: "banque-dialog",
  templateUrl: "banque-dialog.html",
  standalone: false,
})
export class BanqueDialogComponent implements OnInit {
  banque: Banque;
  isLoading: boolean = false;

  constructor(
    public _dr: MatDialogRef<BanqueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public banque_ID: number,
    public _s: BanqueDialogService,
    private _alert: AlertDialogService
  ) {}

  ngOnInit(): void {
    this.getBanque();
  }

  getBanque(): void {
    this.isLoading = true;
    this._s.get(this.banque_ID, (banque: Banque) => {
      this.banque = banque;
      this.isLoading = false;
    });
  }

  postBanque(): void {
    this.isLoading = true;
    this._s.post(this.banque, (banque: Banque) => {
      this.banque = banque;
      this.isLoading = false;
    });
  }

  deleteBanque(): void {
    this._alert.openConfirm(
      "Voulez-vous vraiment supprimer cette banque ?",
      () => {
        this.isLoading = true;
        this._s.delete(this.banque.banque_ID, () => {
          this.isLoading = false;
          this._dr.close(true);
        });
      }
    );
  }

  close(): void {
    this._dr.close(false);
  }
}
